(() => {
  if (window.HpmCartPointsLoaded) return;
  window.HpmCartPointsLoaded = true;

  const roots = () => document.querySelectorAll('[data-hpm-cart-points]');
  const wholeHundreds = (value) => Math.max(0, Math.floor(Number(value || 0) / 100) * 100);
  const maximumFor = (root) => Math.min(
    Number(root.dataset.availablePoints || 0),
    Number(root.dataset.cartLimitPoints || 0),
  );
  let statusPromise;
  let initializationScheduled = false;

  function showMessage(root, text, isError = false) {
    const message = root.querySelector('[data-hpm-cart-message]');
    if (!message) return;
    message.textContent = text;
    message.classList.toggle('is-error', isError);
    message.hidden = !text;
  }

  function update(root) {
    const input = root.querySelector('[data-hpm-cart-input]');
    const button = root.querySelector('[data-hpm-cart-apply]');
    if (!input || !button) return;
    const points = Number(input.value || 0);
    const maximum = maximumFor(root);
    const valid = Number.isInteger(points) && points >= 100 && points % 100 === 0 && points <= maximum;
    root.querySelector('[data-hpm-cart-discount]').textContent = `可折抵 HK$${valid ? points / 100 : 0}`;
    root.querySelector('[data-hpm-cart-limit]').textContent = `本次最多可使用 ${maximum.toLocaleString('zh-HK')} 點`;
    button.disabled = !valid;
  }

  async function initialize(root) {
    if (root.dataset.hpmReady === 'true') return;
    const input = root.querySelector('[data-hpm-cart-input]');
    const button = root.querySelector('[data-hpm-cart-apply]');
    if (!input || !button) return;
    root.dataset.hpmReady = 'true';

    const cartTotalCents = Number(root.dataset.cartTotalCents || 0);
    root.dataset.cartLimitPoints = String(wholeHundreds(cartTotalCents / 2));
    input.addEventListener('input', () => {
      const maximum = maximumFor(root);
      if (Number(input.value) > maximum) {
        input.value = String(maximum);
        showMessage(root, `已自動調整為本次可使用上限 ${maximum.toLocaleString('zh-HK')} 點。`);
      } else {
        showMessage(root, '');
      }
      update(root);
    });
    button.addEventListener('click', async () => {
      const points = Number(input.value);
      const maximum = maximumFor(root);
      if (!Number.isInteger(points) || points < 100 || points % 100 !== 0 || points > maximum) return;
      button.disabled = true;
      button.textContent = '正在套用…';
      showMessage(root, '');
      try {
        const response = await fetch('/apps/hpm-loyalty/api/redeem', {
          method: 'POST',
          headers: { Accept: 'application/json', 'Content-Type': 'application/json' },
          body: JSON.stringify({ points }),
        });
        const data = await response.json();
        if (!response.ok) throw new Error(data.error || 'redeem_failed');
        window.location.assign(`/discount/${encodeURIComponent(data.code)}?redirect=/cart`);
      } catch (error) {
        const messages = {
          insufficient_points: '積分不足，請重新輸入。',
          invalid_points: '請輸入 100 的倍數。',
          points_changed_retry: '積分剛有變動，請重新整理後再試。',
        };
        button.textContent = '套用積分';
        update(root);
        showMessage(root, messages[error.message] || '暫時未能套用積分，積分未被扣除，請稍後再試。', true);
      }
    });

    try {
      statusPromise ||= fetch('/apps/hpm-loyalty/api/status', { headers: { Accept: 'application/json' } })
        .then(async (response) => {
          const data = await response.json();
          if (!response.ok) throw new Error(data.error || 'status_failed');
          return data;
        });
      const data = await statusPromise;
      const available = wholeHundreds(data.points);
      root.dataset.availablePoints = String(available);
      input.max = String(Math.min(available, Number(root.dataset.cartLimitPoints || 0)));
      input.disabled = available < 100 || Number(root.dataset.cartLimitPoints || 0) < 100;
      root.querySelector('[data-hpm-cart-balance]').textContent = `可用積分：${Number(data.points || 0).toLocaleString('zh-HK')} 點`;
      update(root);
    } catch (error) {
      input.disabled = true;
      root.querySelector('[data-hpm-cart-balance]').textContent = '暫時未能讀取積分';
      showMessage(root, '請重新整理頁面後再試。', true);
    }
  }

  function initializeAll() {
    roots().forEach(initialize);
  }

  function scheduleInitialization() {
    if (initializationScheduled) return;
    initializationScheduled = true;
    requestAnimationFrame(() => {
      initializationScheduled = false;
      initializeAll();
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', scheduleInitialization);
  else scheduleInitialization();
  new MutationObserver(scheduleInitialization).observe(document.documentElement, { childList: true, subtree: true });
})();
